// NOTE: classic script version (no ES module syntax).
// Depends on: window.renderDrawerModal (from quick-drawer-product.js)

(function () {
  function lockScroll() {
    const root = document.documentElement;
    const body = document.body;
    const scrollY = window._colorSwatchScrollY || window.scrollY || 0;
    if (scrollY !== 0) {
      window._colorSwatchScrollY = scrollY;
    }
    const sbw = window.innerWidth - document.documentElement.clientWidth;
    root.style.setProperty('--qv-scroll-y', `${scrollY}px`);
    root.style.setProperty('--qv-scrollbar-w', `${sbw}px`);
    root.classList.add('qv-lock');
    body.classList.add('qv-body-fixed');
  }
  function unlockScroll() {
    const root = document.documentElement;
    const body = document.body;
    const saved = parseInt(getComputedStyle(root).getPropertyValue('--qv-scroll-y')) || 0;
    root.classList.remove('qv-lock');
    body.classList.remove('qv-body-fixed');
    root.style.removeProperty('--qv-scroll-y');
    root.style.removeProperty('--qv-scrollbar-w');
    window._colorSwatchScrollY = window.scrollY;
    window.scrollTo(0, saved);
  }

  const QuickAddProductSideDrawer = {
    overlay: null,
    drawer: null,
    section: null,
    isLoading: false,
    handle: null,
    closeButton: null,
    isPDP: false,
    ifdisplayedProductClicked: false,
    productClickedInPdp: false,

    initialize() {
      this.overlay = document.querySelector('.js-quick-add-drawer-overlay');
      this.drawer = document.querySelector('.js-quick-add-product-drawer');
      this.section = this.drawer.querySelector('.js-drawer-section-content');
      this.closeButton = this.drawer.querySelector('.js-quick-add-drawer-close-btn');

      this.hide();
      this.initClose();
      this.initEscClose();
      this.initDelegatedCTAs();

      window.QuickBuy = {
        trigger: this.trigger.bind(this),
        hide: this.hide.bind(this),
      };

      if (window.location.pathname.includes('/products/')) {
        window.addEventListener('resize', this.handleResize.bind(this));
        this.handleResize();
      }
    },

    show() {
      this.drawer.classList.add('is-open');
      this.overlay.classList.add('is-open');

      if (this.isPDP || this.productClickedInPdp) {
        document.body.style.overflow = 'hidden';
        window.dispatchEvent(new CustomEvent('pdpVariantChange'));
        return;
      }
      lockScroll();
      this.trapFocus();
    },

    hide() {
      this.drawer.classList.remove('is-open');
      this.overlay.classList.remove('is-open');

      if (this.isPDP || this.productClickedInPdp) {
        document.body.style.overflow = '';
        window.dispatchEvent(new CustomEvent('syncVariantWithURL'));
      } else {
        unlockScroll();
      }
      this.releaseFocus();
    },

    initClose() {
      const close = () => this.hide();
      if (this.closeButton) this.closeButton.addEventListener('click', close);
      if (this.overlay) this.overlay.addEventListener('click', close);
    },

    initEscClose() {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.drawer.classList.contains('is-open')) this.hide();
      });
    },

    initDelegatedCTAs() {
      document.addEventListener('click', (e) => {
        const el = e.target.closest('[data-quick-view-handle]');
        if (!el) return;

        // Skip if clicking on color swatches in quick drawer
        if (el.classList.contains('qd-swatch-label')) {
          return;
        }

        e.preventDefault();

        // Check if we need to close the cart drawer
        const shouldCloseCart = el.getAttribute('data-close-cart') === 'true';
        if (shouldCloseCart) {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && cartDrawer.open) {
            cartDrawer.hide();
          }
        }

        const productCard = el.closest('product-card');
        let handle = el.getAttribute('data-quick-view-handle');
        let variantId = null;
        if (!handle) return;

        if (!productCard?.querySelector('#product-swatch-cross-links')) {
          const swatchVariantId = productCard
            ?.querySelector('.product-card__swatch-list :checked + .color-swatch')
            ?.getAttribute('data-swatch-variant-id');

          if (swatchVariantId) variantId = swatchVariantId;
        }

        const productHandle = variantId ? `${handle}?variant=${variantId}` : handle;
        this.trigger(productHandle);
      });
    },

    async trigger(
      productHandle,
      isPDP = false,
      ifdisplayedProductClicked = false,
      productClickedInPdp = false
    ) {
      // Parse variant parameter from productHandle if present
      let cleanHandle = productHandle;
      let variantId = null;

      if (productHandle.includes('?variant=') || productHandle.includes('?variantId=')) {
        const [handle, queryString] = productHandle.split('?');
        cleanHandle = handle;

        // Extract variant ID from query string
        const urlParams = new URLSearchParams(queryString);
        variantId = urlParams.get('variant') || urlParams.get('variantId');
      }

      if (this.handle === cleanHandle && !this.isLoading && !variantId) {
        this.show();
        return;
      }
      if (this.isLoading) return;

      this.isLoading = true;
      this.handle = cleanHandle;
      this.isPDP = !!isPDP;
      this.ifdisplayedProductClicked = !!ifdisplayedProductClicked;
      this.productClickedInPdp = !!productClickedInPdp;

      try {
        // inside trigger(), replace the old fetch block with:
        const sectionName = 'quick-drawer-product';
        // Include variant parameter in the URL so Shopify pre-selects the correct variant
        let url = `/products/${encodeURIComponent(this.handle)}?sections=${encodeURIComponent(sectionName)}&_=${Date.now()}`;
        if (variantId) {
          url += `&variant=${encodeURIComponent(variantId)}`;
        }
        const res = await fetch(url, { credentials: 'same-origin' });
        if (!res.ok) throw new Error(`Section fetch failed (${res.status})`);
        const json = await res.json();
        const productHTML = json[sectionName];
        if (!productHTML) throw new Error(`No HTML returned for section "${sectionName}"`);
        window.renderDrawerModal(
          this.section,
          productHTML,
          this.isPDP,
          ifdisplayedProductClicked,
          this.productClickedInPdp,
          variantId // Pass variant ID to the drawer
        );
        this.show();
      } catch (err) {
        console.error(err);
        alert("Sorry, we couldn't load the Quick View.");
      } finally {
        this.isLoading = false;
      }
    },

    handleResize() {
      if (window.innerWidth >= 1024 && this.drawer.classList.contains('is-open')) {
        this.hide();
      }
    },

    trapFocus() {
      const focusables = this.drawer.querySelectorAll(
        'a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])'
      );
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      this._focusHandler = (e) => {
        if (e.key !== 'Tab') return;
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      };
      document.addEventListener('keydown', this._focusHandler);
      (first || this.drawer).focus();
    },
    releaseFocus() {
      if (this._focusHandler) document.removeEventListener('keydown', this._focusHandler);
      this._focusHandler = null;
    },
  };

  document.addEventListener('DOMContentLoaded', () => QuickAddProductSideDrawer.initialize());
  // optional: expose controller for debugging
  window.QuickAddProductSideDrawer = QuickAddProductSideDrawer;
})();
